import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const roleInitialValues = {
  name: "",
  baseRole: 0,
  specialistType: 0
};

export const roleValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  baseRole: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  specialistType: Yup.number().optional(),
});

export type RoleValues = typeof roleInitialValues;
